<template lang="pug">
  .pagination
    .pagination-items
      pagination-button(@click="$emit('click', 'front')" pageLink="front" class="item" :class="{ disabled: !hasPreviousPage }")
      pagination-button(@click="$emit('click', 'previous')" pageLink="previous" class="item" :class="{ disabled: !hasPreviousPage }")
      label.item {{ currentPageNumber }} of {{ totalPageCount }}
      pagination-button(@click="$emit('click', 'next')" pageLink="next" class="item" :class="{ disabled: !hasNextPage }")
      pagination-button(@click="$emit('click', 'last')" pageLink="last" class="item" :class="{ disabled: !hasNextPage }")
</template>

<style lang="scss" scoped>
.pagination {
  text-align: center;

  .pagination-items {
    width: 295px;
    display: inline-block;
  }

  .item:nth-child(even) {
    margin: 0 12px;
  }

  label.item {
    display: inline-block;
    line-height: 40px;
    width: 86px;
  }
}
</style>

<script>
import PaginationButton from '@/components/atoms/PaginationButton'

export default {
  components: {
    PaginationButton,
  },
  props: {
    currentPageNumber: { type: Number, default: 0 },
    totalPageCount: { type: Number, default: 0 },
    hasPreviousPage: { type: Boolean, default: false },
    hasNextPage: { type: Boolean, default: false },
  },
}
</script>
